const css = require('../_sass/main.scss');
import { createApp } from 'vue';
import router from '@/routers/index';
import Vue3TouchEvents from 'vue3-touch-events';
import App from '@/App.vue';
createApp(App).use(Vue3TouchEvents).use(router).mount('#app');
